(function () {
    'use strict';

    angular.module('Directives').directive('bbaMapWaypoints', bbaMapWaypoints);

    bbaMapWaypoints.$inject = ['$q', 'GoogleMapService'];

    function bbaMapWaypoints($q, GoogleMapService) {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/bbaMapWaypoints.html',
            scope: {
                mapData: '=',
            },
            link: bbaMapWaypointsLink
        };

        function bbaMapWaypointsLink($scope) {
            const mapClusterIcon = 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m';

            $scope.initMap = initMap;

            function initMap() {
                let locations = angular.copy($scope.mapData.locationData);
                let polyLineStart = $scope.mapData.polyLineStart;
                let mapCenter = $scope.mapData.mapCenter.position;
                let mapControls = $scope.mapData.mapControls;
                let zoom = $scope.mapData.config.zoom ? $scope.mapData.config.zoom : 5;
                if (!$scope.mapData.centerAddress) {
                    let props = { locations, polyLineStart, mapCenter, mapControls, zoom };
                    initMapProperties(props);
                    return false;
                }

                codeAddress($scope.mapData.centerAddress).then(mapCenter => {
                    initMapProperties({ locations, polyLineStart, mapCenter, mapControls, zoom });
                }).catch(() => {
                    let props = { locations, polyLineStart, mapCenter, mapControls, zoom };
                    initMapProperties(props);
                });
            }

            function initMapProperties(props) {
                let { locations, polyLineStart, mapCenter, mapControls, zoom } = props;
                const infoWindow = new google.maps.InfoWindow();
                $scope.mapData.map = new google.maps.Map(document.getElementById('map'), {
                    center: mapCenter,
                    zoom: zoom,
                    maxZoom: 20,
                    clickableIcons: false,
                    disableDefaultUI: !$scope.mapData.enableDefaultUI,
                    zoomControl: true,
                    zoomControlOptions: {
                        position: google.maps.ControlPosition.LEFT_BOTTOM
                    }
                });
                $scope.mapData.map.addListener('click', function (e) {
                    $scope.mapData.onMapClick($scope.mapData.map, e);
                });
                $scope.mapData.resetCenter = function () {
                    $scope.mapData.map.setCenter(mapCenter);
                    $scope.mapData.map.setZoom($scope.mapData.config.zoom);
                };
                $scope.mapData.markers = locations.map(function (loc, index) {
                    let image = null;
                    if (loc.icon) {
                        image = {
                            url: loc.icon,
                            //size: new google.maps.Size(20, 32),
                            origin: new google.maps.Point(0, 0),
                            anchor: new google.maps.Point(0, 0)
                        }
                    }
                    const marker = new google.maps.Marker({
                        position: { lat: loc.latitude, lng: loc.longitude },
                        icon: image
                    });
                    marker.addListener('click', () => {
                        loc.onPinClick ? loc.onPinClick(marker, loc) : null;
                    });
                    $scope.mapData.locationData[index].marker = marker;
                    return marker;
                });
                $scope.mapData.markerCluster = new MarkerClusterer($scope.mapData.map, $scope.mapData.markers, {
                    imagePath: mapClusterIcon,
                    maxZoom: 20,
                    averageCenter: true
                });

                for (let i = 0; i < mapControls.length; i++) {
                    let controlDiv = document.createElement('div');
                    let control = new mapControls[i].control(controlDiv, $scope.mapData.map);
                    controlDiv.index = 1;
                    $scope.mapData.map.controls[google.maps.ControlPosition[mapControls[i].position]].push(controlDiv);
                }

                $scope.mapData.onMapMount ? $scope.mapData.onMapMount($scope.mapData.map) : null;
            }

            function codeAddress(address) {
                let defer = $q.defer();
                if (!address) { return; }

                const payload = {
                    serviceName: 'admin AU',
                    methodName: 'getLatLng',
                    address: address
                }
                GoogleMapService.geocoder(success => {
                    console.log('waypoint geocoder is working');
                    defer.resolve(success);
                }, error => {
                    defer.reject(error);
                }, payload);
                
                return defer.promise;
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/bbaMapWaypoint.js